import { ModuleName } from '@/constant/modules.constants';
import {
  deleteFile,
  getObjects,
  isStorageImageFile,
  uploadPublicFile,
} from '@/lib/api/services/storage.service';
import type { MediaAsset, MediaLibraryFilter } from '../types/media-library.types';
import { matchesTypeFilter, storageItemToMediaAsset } from '../utils/media-library.utils';

export const listMediaAssets = async (
  filter: MediaLibraryFilter = {}
): Promise<MediaAsset[]> => {
  const search = filter.search?.trim();
  const response = await getObjects({
    limit: 100,
    search: search || undefined,
  });

  const rawItems = (response.data ?? []).filter(isStorageImageFile);
  const assets = rawItems.map(storageItemToMediaAsset);

  if (filter.type && filter.type !== 'ALL') {
    return assets.filter((asset) => matchesTypeFilter(asset, filter.type));
  }

  return assets;
};

export const uploadMediaAsset = async (
  file: File
): Promise<{ fileId: string; fileUrl: string }> => {
  return uploadPublicFile(file, ModuleName.DefaultCloud);
};

export const deleteMediaAsset = async (
  fileId: string
): Promise<{ isSuccess: boolean }> => {
  return deleteFile(fileId, true);
};
